import { useEffect, useState, useContext, useRef } from "react";
import { NavLink } from "react-router-dom";
import { petitions } from "../../../api/calls";
import { DataContext } from "../../../context/DataContext";
import { toast } from "sonner";
import { useForm } from "react-hook-form";
import Table from "../../componentsTable/TableClient";
import Swal from "sweetalert2";
import Select from "react-select";
import TableLoad from "../../componentsTools/TableLoad";
import { exportToExcel_v2 } from "../../componentsTools/ExportToExcel";
import customStyles from "../../../frontend/styles/select";

export default function VerCliente() {
  const { session, idEmpresa } = useContext(DataContext);
  const [filtering, setFiltering] = useState("");
  const [estadoTabla, setEstadoTabla] = useState(false);
  const [idCont, setIdcont] = useState("");
  const [load, setLoad] = useState(true);

  //SELECTS
  const [tPersona, setTPersona] = useState([]);
  const [tIdentidad, setTIdentidad] = useState([]);
  const [pais, setPais] = useState([]);
  const [region, setRegion] = useState([]);
  const [distrito, setDistrito] = useState([]);
  const [provincia, setProvincia] = useState([]);
  const [moneda, setMoneda] = useState([]);
  const [tPago, setTpago] = useState([]);
  const [rubro, setRubro] = useState([]);

  const sexo = [
    { value: "", label: "Ninguno" },
    { value: "M", label: "Masculino" },
    { value: "F", label: "Femenino" },
  ];

  const tipo = [
    { value: "C", label: "Cliente" },
    { value: "P", label: "Proveedor" },
  ];

  const [clientes, setClientes] = useState([]);

  const modalRef = useRef(null);
  const modalRefFilter = useRef(null);

  const closeModal = () => {
    const modalInstance = window.bootstrap.Modal.getInstance(modalRef.current);
    modalInstance.hide();
  };

  const form1 = useForm({
    defaultValues: {},
  });

  const form2 = useForm({
    defaultValues: {
      tipo: "",
      idRubro: "",
      bloqueado: "",
    },
  });

  const filtrosActivos =
    !!form2.watch("tipo") ||
    !!form2.watch("idRubro") ||
    !!form2.watch("bloqueado");

  const aplicarFiltros = form2.handleSubmit(() => {
    const modalInstance = window.bootstrap.Modal.getInstance(modalRefFilter.current);
    modalInstance.hide();
    setEstadoTabla(!estadoTabla);
  });

  const updateCliente = form1.handleSubmit(async (data) => {
    data.idcont = idCont;
    data.detraccion = data.detraccion ? "S" : "N";
    data.percepcion = data.percepcion ? "S" : "N";
    data.retencion = data.retencion ? "S" : "N";
    data.kardex = data.kardex ? "S" : "N";

    const response = await petitions.updateCliente(
      idEmpresa(),
      session().token,
      data,
    );
    if (response.status === "success") {
      if (response.data) {
        setEstadoTabla(!estadoTabla);
        closeModal();
        toast.success("Cliente actualizado correctamente");
      } else {
        toast.warning("Ocurrió un problema, inténtelo mas tarde");
      }
    } else {
      var msg =
        typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  });

  const columns = [
    {
      header: (
        <th
          className="sort align-middle ps-3 pe-5 text-uppercase border-end border-translucent"
          scope="col"
          data-sort="name"
          style={{ width: "10%" }}
        >
          Tipo
        </th>
      ),
      accessorKey: "tipo",
      cell: ({ row }) => (
        <td className="align-middle white-space-nowrap fw-semibold ps-3 border-end border-translucent">
          {row.original.tipo === "P" ? "Proveedor" : "Cliente"}
        </td>
      ),
    },
    {
      header: (
        <th
          className="sort align-middle ps-3 pe-5 text-uppercase border-end border-translucent"
          scope="col"
          data-sort="name"
          style={{ width: "15%" }}
        >
          DNI / RUC
        </th>
      ),
      accessorKey: "nroDoc",
      cell: ({ row }) => (
        <td className="align-middle white-space-nowrap fw-semibold ps-3 border-end border-translucent">
          {row.original.nroDoc}
        </td>
      ),
    },
    {
      header: (
        <th
          className="sort align-middle ps-3 pe-5 text-uppercase border-end border-translucent"
          scope="col"
          data-sort="email"
          style={{ width: "20%" }}
        >
          <div className="d-inline-flex flex-center">
            <span>Nombre</span>
          </div>
        </th>
      ),
      accessorKey: "razon",
      cell: ({ row }) => (
        <td
          className="align-middle white-space-nowrap fw-semibold ps-3 border-end border-translucent"
          style={{
            wordWrap: "break-word",
            overflowWrap: "break-word",
            whiteSpace: "normal",
          }}
        >
          {row.original.razon}
        </td>
      ),
    },
    {
      header: (
        <th
          className="sort align-middle ps-3 pe-5 text-uppercase border-end border-translucent"
          scope="col"
          data-sort="phone"
          style={{ width: "15%", minWidth: "180px" }}
        >
          <div className="d-inline-flex flex-center">
            <div
              className="d-flex align-items-center px-1 py-1 bg-primary-subtle rounded me-2"
              style={{ width: "27px" }}
            >
              <span className="text-primary-dark" data-feather="map-pin"></span>
            </div>
            <span>Dirección Fiscal</span>
          </div>
        </th>
      ),
      accessorKey: "direccion",
      cell: ({ row }) => (
        <td
          className="align-middle white-space-nowrap fw-semibold ps-3 border-end border-translucent"
          style={{
            wordWrap: "break-word",
            overflowWrap: "break-word",
            whiteSpace: "normal",
          }}
        >
          {row.original.direccion}
        </td>
      ),
    },
    {
      header: (
        <th
          className="sort align-middle ps-3 pe-5 text-uppercase border-end border-translucent"
          scope="col"
          data-sort="contact"
          style={{ width: "15%" }}
        >
          <div className="d-inline-flex flex-center">
            <div
              className="d-flex align-items-center px-1 py-1 bg-success-subtle rounded me-2"
              style={{ width: "27px" }}
            >
              <span className="text-success-dark" data-feather="mail"></span>
            </div>
            <span>Email</span>
          </div>
        </th>
      ),
      accessorKey: "email",
      cell: ({ row }) => (
        <td
          className="align-middle fw-semibold ps-3 border-end border-translucent"
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            paddingTop: 0,
            paddingBottom: 0,
            lineHeight: "1.4",
          }}
        >
          <a
            className="text-info text-decoration-none"
            href={`mailto:${row.original.email}`}
            style={{
              display: "inline-block",
              width: "100%",
              wordBreak: "break-word",
            }}
          >
            {row.original.email}
          </a>
        </td>
      ),
    },
    {
      header: (
        <th
          className="sort align-middle ps-3 pe-5 text-uppercase border-end border-translucent"
          scope="col"
          data-sort="company"
          style={{ width: "15%" }}
        >
          <div className="d-inline-flex flex-center">
            <div
              className="d-flex align-items-center px-1 py-1 bg-primary-subtle rounded me-2"
              style={{ width: "27px" }}
            >
              <span className="text-primary-dark" data-feather="phone"></span>
            </div>
            <span>Celular</span>
          </div>
        </th>
      ),
      accessorKey: "celular",
      cell: ({ row }) => (
        <td className="align-middle white-space-nowrap fw-semibold ps-3 border-end border-translucent">
          {row.original.celular}
        </td>
      ),
    },
    {
      header: (
        <th
          className="sort align-middle ps-3 pe-5 text-uppercase border-end border-translucent"
          scope="col"
          data-sort="company"
          style={{ width: "15%" }}
        >
          <div className="d-inline-flex flex-center">
            <div
              className="d-flex align-items-center px-1 py-1 bg-warning-subtle rounded me-2"
              style={{ width: "27px" }}
            >
              <span
                className="text-warning-dark"
                data-feather="alert-circle"
              ></span>
            </div>
            <span>Estado</span>
          </div>
        </th>
      ),
      accessorKey: "bloqueado",
      cell: ({ row }) => (
        <td className="align-middle white-space-nowrap fw-semibold ps-3 border-end border-translucent">
          {row.original.bloqueado === "N" ? (
            <span className="badge text-bg-success rounded-4">
              <span className="badge-label">Activo</span>
            </span>
          ) : (
            <span className="badge text-bg-danger rounded-4">
              <span className="badge-label">Inactivo</span>
            </span>
          )}
        </td>
      ),
    },
    {
      header: (
        <th className="sort text-end align-middle pe-3 ps-4" scope="col"></th>
      ),
      accessorKey: "acciones",
      cell: ({ row }) => (
        <td className="product align-middle ps-4">
          <div className="btn-reveal-trigger position-static">
            <button
              className="btn btn-sm dropdown-toggle dropdown-caret-none transition-none btn-reveal fs-10"
              type="button"
              data-bs-toggle="dropdown"
              data-boundary="window"
              aria-haspopup="true"
              aria-expanded="false"
              data-bs-reference="parent"
            >
              <span className="fas fa-ellipsis-h fs-10"></span>
            </button>
            <div className="dropdown-menu dropdown-menu-end py-2">
              <button
                className="dropdown-item text-body"
                onClick={() => {
                  toast.warning("Funcionalidad aun no disponible");
                }}
              >
                Kardex
              </button>
              <button
                className="dropdown-item text-body"
                onClick={() => {
                  updateEstadoCliente(row.original);
                }}
              >
                {row.original.bloqueado === "N" ? "Inhabilitar" : "Habilitar"}
              </button>
              <div className="dropdown-divider"></div>
              <button
                className="dropdown-item text-info"
                onClick={() => {
                  channel(row.original);
                }}
              >
                Editar
              </button>
              <button
                className="dropdown-item text-danger"
                onClick={() => {
                  deleteCliente(row.original.idcont);
                }}
              >
                Eliminar
              </button>
            </div>
          </div>
        </td>
      ),
    },
  ];

  const updateEstadoCliente = async (row) => {
    row.bloqueado = row.bloqueado === "N" ? "S" : "N";
    const response = await petitions.bloquearCliente(
      idEmpresa(),
      session().token,
      row,
    );

    if (response.status === "success") {
      setEstadoTabla(!estadoTabla);
      toast.success(
        row.bloqueado === "N"
          ? "Cliente habilitado correctamente"
          : "Cliente inhabilitado correctamente",
      );
    } else {
      const msg =
        typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  };

  const channel = (obj) => {
    setIdcont(obj.idcont);

    form1.setValue("nroDoc", obj.nroDoc, { shouldValidate: true });
    form1.setValue("razon", obj.razon, { shouldValidate: true });
    form1.setValue("celular", obj.celular, { shouldValidate: true });
    form1.setValue("paterno", obj.paterno, { shouldValidate: true });
    form1.setValue("materno", obj.materno, { shouldValidate: true });
    form1.setValue("nombre1", obj.nombre1, { shouldValidate: true });
    form1.setValue("nombre2", obj.nombre2, { shouldValidate: true });
    form1.setValue("direccion", obj.direccion, { shouldValidate: true });
    form1.setValue("email", obj.email, { shouldValidate: true });
    form1.setValue("obs", obj.obs, { shouldValidate: true });
    form1.setValue("telefono1", obj.telefono1, { shouldValidate: true });
    form1.setValue("telefono2", obj.telefono2, { shouldValidate: true });

    form1.setValue("retencion", obj.retencion === "S" ? true : false, {
      shouldValidate: true,
    });
    form1.setValue("percepcion", obj.percepcion === "S" ? true : false, {
      shouldValidate: true,
    });
    form1.setValue("detraccion", obj.detraccion === "S" ? true : false, {
      shouldValidate: true,
    });

    form1.setValue("idTDIdentidad", obj.idTDIdentidad, {
      shouldValidate: true,
    });
    form1.setValue("idTPersona", obj.idTPersona, { shouldValidate: true });
    form1.setValue("sexo", obj.sexo, { shouldValidate: true });
    form1.setValue("tipo", obj.tipo, { shouldValidate: true });
    form1.setValue("idPais", obj.idPais, { shouldValidate: true });
    form1.setValue("idRegion", obj.idRegion, { shouldValidate: true });
    form1.setValue("idDistrito", obj.idDistrito, { shouldValidate: true });
    form1.setValue("idProvincia", obj.idProvincia, { shouldValidate: true });
    form1.setValue("idMoneda", obj.idMoneda, { shouldValidate: true });
    form1.setValue("tpago", obj.tPago, { shouldValidate: true });
    form1.setValue("idRubro", obj.idRubro, { shouldValidate: true });

    form1.setValue("kardex", obj.kardex === "S" ? true : false);

    const modal = new window.bootstrap.Modal(modalRef.current);
    modal.show();
    document.querySelector('[data-wizard-step="1"]').click();
  };

  const deleteCliente = (idcont) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Estas seguro/a?",
        text: "No podrás cancelar el proceso",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, eliminar",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          const response = await petitions.deleteCliente(
            idEmpresa(),
            session().token,
            { idcont },
          );
          if (response.status === "success") {
            if (response.data) {
              setEstadoTabla(!estadoTabla);
              toast.success("Cliente eliminado correctamente");
            } else {
              toast.warning("Ocurrió un problema, inténtelo mas tarde");
            }
          } else {
            var msg =
              typeof response.code === "string"
                ? response.message
                : response.data;
            toast.error(msg);
          }
        }
      });
  };

  useEffect(() => {
    const fetchClientes = async () => {
      setLoad(true);
      const response = await petitions.getClientes(
        idEmpresa(),
        session().token,
        {
          tipo: form2.watch("tipo") || "",
          idRubro: form2.watch("idRubro") || "",
          bloqueado: form2.watch("bloqueado") || "",
        }
      );
      if (response.status === "success") {
        setClientes(response.data);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
      setLoad(false);
    };

    fetchClientes();
  }, [estadoTabla, idEmpresa, session]);

  useEffect(() => {
    const fetchTDIdentidad = async () => {
      const response = await petitions.getTDIdentidad(
        idEmpresa(),
        session().token,
      );
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));
        setTIdentidad(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchTDIdentidad();
  }, [form1, session, idEmpresa]);

  useEffect(() => {
    const fetchTPersona = async () => {
      const response = await petitions.getTPersona(
        idEmpresa(),
        session().token,
      );
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));
        setTPersona(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchTPersona();
  }, [form1, session, idEmpresa]);

  useEffect(() => {
    const fetchPais = async () => {
      const response = await petitions.getPais(idEmpresa(), session().token);
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));
        setPais(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchPais();
  }, [form1, session, idEmpresa]);

  useEffect(() => {
    const fetchRegion = async () => {
      const response = await petitions.getRegion(idEmpresa(), session().token);
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));
        setRegion(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchRegion();
  }, [form1, session, idEmpresa]);

  useEffect(() => {
    const fetchDistrito = async () => {
      const response = await petitions.getDistrito(
        idEmpresa(),
        session().token,
      );
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));
        setDistrito(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchDistrito();
  }, [form1, session, idEmpresa]);

  useEffect(() => {
    const fetchProvincia = async () => {
      const response = await petitions.getProvincia(
        idEmpresa(),
        session().token,
      );
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idProvincia,
          label: e.descripcion,
        }));
        setProvincia(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchProvincia();
  }, [form1, session, idEmpresa]);

  useEffect(() => {
    const fetchMoneda = async () => {
      const response = await petitions.getMoneda(idEmpresa(), session().token);
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idMoneda.toString(),
          label: `${e.simbolo} - ${e.descripcion}`,
        }));
        setMoneda(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchMoneda();
  }, [form1, session, idEmpresa]);

  useEffect(() => {
    const fetchTPago = async () => {
      const obj = session();
      const response = await petitions.getTPago(idEmpresa(), obj.token);
      if (response.status === "success") {
        var array = [];
        response.data.forEach((e) => {
          array.push({ value: e.idTpago, label: e.descripcion });
        });
        setTpago(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchTPago();
  }, [idEmpresa, session]);

  useEffect(() => {
    const fetchRubro = async () => {
      const response = await petitions.getRubroContribuyente(
        idEmpresa(),
        session().token,
      );
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));
        setRubro(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchRubro();
  }, [form1, session, idEmpresa]);

  return (
    <>
      <div className="mb-9">
        <div className="row g-3 mb-1">
          <div className="col-auto">
            <h2 className="mb-0">Clientes</h2>
          </div>
        </div>
        <ul className="nav nav-links mb-3 mb-lg-2 mx-n3">
          <li className="nav-item">
            <div className="nav-link disabled" aria-current="page">
              <span>Todo </span>
              <span className="text-body-tertiary fw-semibold">
                ({clientes?.length})
              </span>
            </div>
          </li>
          <li className="nav-item">
            <div className="nav-link disabled">
              <span className="text-success">Clientes </span>
              <span className="text-body-tertiary fw-semibold">
                ({clientes?.filter((cliente) => cliente.tipo === "C").length})
              </span>
            </div>
          </li>
          <li className="nav-item">
            <div className="nav-link disabled">
              <span className="text-warning">Proveedores </span>
              <span className="text-body-tertiary fw-semibold">
                ({clientes?.filter((cliente) => cliente.tipo === "P").length})
              </span>
            </div>
          </li>
        </ul>
        <div
          id="products"
          data-list='{"valueNames":["product","price","category","tags","vendor","time"],"page":10,"pagination":true}'
        >
          <div className="mb-4">
            <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
              <div className="ms-xxl-auto">
                <NavLink
                  className="btn btn-primary rounded-4"
                  to={"/main/NuevoCliente"}
                >
                  <span className="fas fa-plus me-2"></span>Agregar cliente
                </NavLink>
              </div>
              <div className="ms-xxl-auto">
                <NavLink
                  className="btn btn-subtle-info pointer-events-none rounded-4"
                  to={"/main/importclientes"}
                >
                  <span className="fas fa-upload me-2"></span>Importar clientes
                </NavLink>
              </div>
              <div className="search-box">
                <input
                  className="form-control search-input search rounded-4 border-0 shadow-sm"
                  type="search"
                  placeholder="Buscar clientes"
                  aria-label="Search"
                  value={filtering}
                  onChange={(e) => setFiltering(e.target.value)}
                />
                <span className="fas fa-search search-box-icon"></span>
              </div>
              <button
                className="btn px-3 btn-phoenix-secondary rounded-4"
                type="button"
                title="Filtros"
                onClick={() => {
                  const modal = new window.bootstrap.Modal(
                    modalRefFilter.current
                  );
                  modal.show();
                }}
              >
                {filtrosActivos ? "📌" : "⋮"}
              </button>
              <div className="ms-xxl-auto">
                <button
                  className="btn btn-link text-body me-4 px-0 rounded-4"
                  onClick={() =>
                    exportToExcel_v2(clientes, columns, "Clientes")
                  }
                >
                  <span className="fa-solid fa-file-export fs-9 me-2"></span>
                  Exportar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive scrollbar mx-n1 px-1">
          {load ? (
            <TableLoad />
          ) : (
            <Table
              data={clientes}
              columns={columns}
              filtering={filtering}
              setFiltering={setFiltering}
              classNameTable="table fs-9 mb-0 leads-table border-top border-translucent"
              classNameTrHead=""
              classNameTrBody="hover-actions-trigger btn-reveal-trigger position-static"
            />
          )}
        </div>
      </div>
      <div
        className="modal fade bd-example-modal-lg"
        id="modalEditar"
        tabIndex="-1"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-primary">
              <h5
                className="modal-title text-white dark__text-gray-1100"
                id="staticBackdropLabel"
              >
                Editar cliente / proveedor
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9 text-white dark__text-gray-1100"></span>
              </button>
            </div>
            <form onSubmit={updateCliente}>
              <div className="modal-body">
                <ul
                  className="nav nav-underline fs-9 w-100"
                  id="myTab"
                  role="tablist"
                >
                  <li className="nav-item flex-grow-1 text-center">
                    <a
                      className="nav-link active"
                      id="home-tab"
                      data-bs-toggle="tab"
                      href="#tab-home"
                      role="tab"
                      aria-controls="tab-home"
                      aria-selected="true"
                      data-wizard-step="1"
                    >
                      Principal
                    </a>
                  </li>
                  <li className="nav-item flex-grow-1 text-center">
                    <a
                      className="nav-link"
                      id="profile-tab"
                      data-bs-toggle="tab"
                      href="#tab-profile"
                      role="tab"
                      aria-controls="tab-profile"
                      aria-selected="false"
                    >
                      Secundario
                    </a>
                  </li>
                </ul>
                <div className="tab-content mt-3" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="tab-home"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                  >
                    <div className="row g-3">
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Numero de documento
                        </label>
                        <input
                          className="form-control rounded-4"
                          type="number"
                          {...form1.register("nroDoc", {
                            required: {
                              value: true,
                              message: "Este campo es obligatorio",
                            },
                            maxLength: {
                              value: 11,
                              message: "El número de documento es muy largo",
                            },
                          })}
                        />
                        {form1.formState.errors?.nroDoc && (
                          <div className="mb-0">
                            <code>{form1.formState.errors.nroDoc.message}</code>
                          </div>
                        )}
                      </div>
                      <div className="col-6">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Razon / Nombre
                        </label>
                        <input
                          className="form-control rounded-4"
                          type="text"
                          {...form1.register("razon", {
                            required: {
                              value: true,
                              message: "Este campo es obligatorio",
                            },
                            maxLength: {
                              value: 250,
                              message: "Razon / Nombre demasiado largo",
                            },
                          })}
                        />
                        {form1.formState.errors?.razon && (
                          <div className="mb-0">
                            <code>{form1.formState.errors.razon.message}</code>
                          </div>
                        )}
                      </div>
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Celular
                        </label>
                        <input
                          type="text"
                          className="form-control rounded-4"
                          {...form1.register("celular", {
                            maxLength: {
                              value: 30,
                              message: "Celular demasiado largo",
                            },
                          })}
                        />
                      </div>
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Apellido paterno
                        </label>
                        <input
                          type="text"
                          className="form-control rounded-4"
                          {...form1.register("paterno", {
                            maxLength: {
                              value: 100,
                              message: "Apellido paterno demasiado largo",
                            },
                          })}
                        />
                      </div>
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Apellido materno
                        </label>
                        <input
                          type="text"
                          className="form-control rounded-4"
                          {...form1.register("materno", {
                            maxLength: {
                              value: 100,
                              message: "Apellido materno demasiado largo",
                            },
                          })}
                        />
                      </div>
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Nombre
                        </label>
                        <input
                          type="text"
                          className="form-control rounded-4"
                          {...form1.register("nombre1", {
                            maxLength: {
                              value: 100,
                              message: "Nombre demasiado largo",
                            },
                          })}
                        />
                      </div>
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Nombre secundario
                        </label>
                        <input
                          type="text"
                          className="form-control rounded-4"
                          {...form1.register("nombre2", {
                            maxLength: {
                              value: 100,
                              message: "Nombre secundario demasiado largo",
                            },
                          })}
                        />
                      </div>
                      <div className="col-5">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Dirección fiscal
                        </label>
                        <input
                          className="form-control rounded-4"
                          type="text"
                          {...form1.register("direccion", {
                            maxLength: {
                              value: 400,
                              message: "Dirección demasiado largo",
                            },
                          })}
                        />
                        {form1.formState.errors?.direccion && (
                          <div className="mb-0">
                            <code>
                              {form1.formState.errors.direccion.message}
                            </code>
                          </div>
                        )}
                      </div>
                      <div className="col-4">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Correo
                        </label>
                        <input
                          type="email"
                          className="form-control rounded-4"
                          {...form1.register("email", {
                            maxLength: {
                              value: 100,
                              message: "Correo demasiado largo",
                            },
                          })}
                        />
                      </div>
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Observacion
                        </label>
                        <input
                          type="text"
                          className="form-control rounded-4"
                          {...form1.register("obs", {})}
                        />
                      </div>
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Telefono 1
                        </label>
                        <input
                          type="text"
                          className="form-control rounded-4"
                          {...form1.register("telefono1", {})}
                        />
                      </div>
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Telefono 2
                        </label>
                        <input
                          type="text"
                          className="form-control rounded-4"
                          {...form1.register("telefono2", {})}
                        />
                      </div>
                      <div className="col-2 mt-6">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="fragileCheck1"
                            {...form1.register("retencion")}
                          />
                          <label
                            className="form-check-label text-body fs-9"
                            htmlFor="fragileCheck1"
                          >
                            Retención
                          </label>
                        </div>
                      </div>
                      <div className="col-2 mt-6">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="fragileCheck2"
                            {...form1.register("percepcion")}
                          />
                          <label
                            className="form-check-label text-body fs-9"
                            htmlFor="fragileCheck2"
                          >
                            percepcion
                          </label>
                        </div>
                      </div>
                      <div className="col-2 mt-6">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="fragileCheck3"
                            {...form1.register("detraccion")}
                          />
                          <label
                            className="form-check-label text-body fs-9"
                            htmlFor="fragileCheck3"
                          >
                            detraccion
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="tab-profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                  >
                    <div className="row g-3">
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Tipo de indentidad
                        </label>
                        <Select
                          className="mb-0 mi-select mi-select-bordered"
                          classNamePrefix="rs"
                          options={tIdentidad}
                          styles={customStyles}
                          value={
                            tIdentidad.find(
                              (option) =>
                                option.value === form1.watch("idTDIdentidad"),
                            ) || null
                          }
                          {...form1.register("idTDIdentidad", {
                            required: {
                              value: true,
                              message: "Este campo es obligatorio",
                            },
                          })}
                          onChange={(event) => {
                            form1.setValue("idTDIdentidad", event.value);
                          }}
                        />
                        {form1.formState.errors?.idTDIdentidad && (
                          <div className="mb-0">
                            <code>
                              {form1.formState.errors.idTDIdentidad.message}
                            </code>
                          </div>
                        )}
                      </div>
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Tipo de persona
                        </label>
                        <Select
                          className="mb-0 mi-select mi-select-bordered"
                          classNamePrefix="rs"
                          options={tPersona}
                          styles={customStyles}
                          value={
                            tPersona.find(
                              (option) =>
                                option.value === form1.watch("idTPersona"),
                            ) || null
                          }
                          {...form1.register("idTPersona", {
                            required: {
                              value: true,
                              message: "Este campo es obligatorio",
                            },
                          })}
                          onChange={(event) => {
                            form1.setValue("idTPersona", event.value);
                          }}
                        />
                        {form1.formState.errors?.idTPersona && (
                          <div className="mb-0">
                            <code>
                              {form1.formState.errors.idTPersona.message}
                            </code>
                          </div>
                        )}
                      </div>
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Sexo
                        </label>
                        <Select
                          className="mb-0 mi-select mi-select-bordered"
                          classNamePrefix="rs"
                          options={sexo}
                          styles={customStyles}
                          value={
                            sexo.find(
                              (option) => option.value === form1.watch("sexo"),
                            ) || null
                          }
                          {...form1.register("sexo", {})}
                          onChange={(event) => {
                            form1.setValue("sexo", event.value);
                          }}
                        />
                      </div>
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Tipo
                        </label>
                        <Select
                          className="mb-0 mi-select mi-select-bordered"
                          classNamePrefix="rs"
                          options={tipo}
                          styles={customStyles}
                          value={
                            tipo.find(
                              (option) => option.value === form1.watch("tipo"),
                            ) || null
                          }
                          {...form1.register("tipo", {
                            required: {
                              value: true,
                              message: "Este campo es obligatorio",
                            },
                          })}
                          onChange={(event) => {
                            form1.setValue("tipo", event.value);
                          }}
                        />
                        {form1.formState.errors?.tipo && (
                          <div className="mb-0">
                            <code>{form1.formState.errors.tipo.message}</code>
                          </div>
                        )}
                      </div>
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          País
                        </label>
                        <Select
                          className="mb-0 mi-select mi-select-bordered"
                          classNamePrefix="rs"
                          options={pais}
                          styles={customStyles}
                          value={
                            pais.find(
                              (option) =>
                                option.value === form1.watch("idPais"),
                            ) || null
                          }
                          {...form1.register("idPais", {
                            required: {
                              value: true,
                              message: "Este campo es obligatorio",
                            },
                          })}
                          onChange={(event) => {
                            form1.setValue("idPais", event.value);
                          }}
                        />
                        {form1.formState.errors?.idPais && (
                          <div className="mb-0">
                            <code>{form1.formState.errors.idPais.message}</code>
                          </div>
                        )}
                      </div>
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Región
                        </label>
                        <Select
                          className="mb-0 mi-select mi-select-bordered"
                          classNamePrefix="rs"
                          options={region}
                          styles={customStyles}
                          value={
                            region.find(
                              (option) =>
                                option.value === form1.watch("idRegion"),
                            ) || null
                          }
                          {...form1.register("idRegion", {
                            required: {
                              value: true,
                              message: "Este campo es obligatorio",
                            },
                          })}
                          onChange={(event) => {
                            form1.setValue("idRegion", event.value);
                          }}
                        />
                        {form1.formState.errors?.idRegion && (
                          <div className="mb-0">
                            <code>
                              {form1.formState.errors.idRegion.message}
                            </code>
                          </div>
                        )}
                      </div>
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Distrito
                        </label>
                        <Select
                          className="mb-0 mi-select mi-select-bordered"
                          classNamePrefix="rs"
                          options={distrito}
                          styles={customStyles}
                          value={
                            distrito.find(
                              (option) =>
                                option.value === form1.watch("idDistrito"),
                            ) || null
                          }
                          {...form1.register("idDistrito", {
                            required: {
                              value: true,
                              message: "Este campo es obligatorio",
                            },
                          })}
                          onChange={(event) => {
                            form1.setValue("idDistrito", event.value);
                          }}
                        />
                        {form1.formState.errors?.idDistrito && (
                          <div className="mb-0">
                            <code>
                              {form1.formState.errors.idDistrito.message}
                            </code>
                          </div>
                        )}
                      </div>
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Provincia
                        </label>
                        <Select
                          className="mb-0 mi-select mi-select-bordered"
                          classNamePrefix="rs"
                          options={provincia}
                          styles={customStyles}
                          value={
                            provincia.find(
                              (option) =>
                                option.value === form1.watch("idProvincia"),
                            ) || null
                          }
                          {...form1.register("idProvincia", {
                            required: {
                              value: true,
                              message: "Este campo es obligatorio",
                            },
                          })}
                          onChange={(event) => {
                            form1.setValue("idProvincia", event.value);
                          }}
                        />
                        {form1.formState.errors?.idProvincia && (
                          <div className="mb-0">
                            <code>
                              {form1.formState.errors.idProvincia.message}
                            </code>
                          </div>
                        )}
                      </div>
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Moneda
                        </label>
                        <Select
                          className="mb-0 mi-select mi-select-bordered"
                          classNamePrefix="rs"
                          options={moneda}
                          styles={customStyles}
                          value={
                            moneda.find(
                              (option) =>
                                option.value === form1.watch("idMoneda"),
                            ) || null
                          }
                          {...form1.register("idMoneda", {
                            required: {
                              value: true,
                              message: "Este campo es obligatorio",
                            },
                          })}
                          onChange={(event) => {
                            form1.setValue("idMoneda", event.value);
                          }}
                        />
                        {form1.formState.errors?.idMoneda && (
                          <div className="mb-0">
                            <code>
                              {form1.formState.errors.idMoneda.message}
                            </code>
                          </div>
                        )}
                      </div>
                      <div className="col-4">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Tipo de pago
                        </label>
                        <Select
                          className="mb-0 mi-select mi-select-bordered"
                          classNamePrefix="rs"
                          options={tPago}
                          styles={customStyles}
                          value={
                            tPago.find(
                              (option) => option.value === form1.watch("tpago"),
                            ) || null
                          }
                          {...form1.register("tpago", {
                            required: {
                              value: true,
                              message: "Este campo es obligatorio",
                            },
                          })}
                          onChange={(event) => {
                            form1.setValue("tpago", event.value);
                          }}
                        />
                        {form1.formState.errors?.tpago && (
                          <div className="mb-0">
                            <code>{form1.formState.errors.tpago.message}</code>
                          </div>
                        )}
                      </div>
                      <div className="col-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustom01"
                        >
                          Rubro
                        </label>
                        <Select
                          className="mb-0 mi-select mi-select-bordered"
                          classNamePrefix="rs"
                          options={rubro}
                          styles={customStyles}
                          value={
                            rubro.find(
                              (option) =>
                                option.value === form1.watch("idRubro"),
                            ) || null
                          }
                          {...form1.register("idRubro", {
                            required: {
                              value: true,
                              message: "Este campo es obligatorio",
                            },
                          })}
                          onChange={(event) => {
                            form1.setValue("idRubro", event.value);
                          }}
                        />
                        {form1.formState.errors?.idRubro && (
                          <div className="mb-0">
                            <code>
                              {form1.formState.errors.idRubro.message}
                            </code>
                          </div>
                        )}
                      </div>
                      <div className="col-2 mt-7">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            id="fragileCheck4"
                            type="checkbox"
                            {...form1.register("kardex")}
                          />
                          <label
                            className="form-check-label text-body fs-9"
                            htmlFor="fragileCheck4"
                          >
                            Kardex
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Actualizar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="reportsFilterModal"
        tabIndex="-1"
        ref={modalRefFilter}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border border-translucent rounded-4">
            <form
              autoComplete="off"
              onSubmit={aplicarFiltros}
            >
              <div className="modal-header border-translucent p-4">
                <h5 className="modal-title text-body-highlight fs-6 lh-sm">
                  Filtros
                </h5>
                <button
                  className="btn p-1 text-danger"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span className="fas fa-times fs-9"></span>
                </button>
              </div>

              <div className="modal-body pt-4 pb-2 px-4">
                <div className="mb-3">
                  <label className="fw-bold mb-2 text-body-highlight">
                    Tipo
                  </label>

                  <Select
                    className="mb-0 mi-select mi-select-bordered"
                    classNamePrefix="rs"
                    options={[
                      { value: "", label: "Todos" },
                      { value: "C", label: "Cliente" },
                      { value: "P", label: "Proveedor" },
                    ]}
                    styles={customStyles}
                    value={
                      [
                        { value: "", label: "Todos" },
                        { value: "C", label: "Cliente" },
                        { value: "P", label: "Proveedor" },
                      ].find(
                        (option) => option.value === form2.watch("tipo"),
                      ) || null
                    }
                    onChange={(event) => {
                      form2.setValue("tipo", event?.value ?? "");
                    }}
                  />
                </div>

                <div className="mb-3">
                  <label className="fw-bold mb-2 text-body-highlight">
                    Rubro
                  </label>

                  <Select
                    className="mb-0 mi-select mi-select-bordered"
                    classNamePrefix="rs"
                    options={[{ value: "", label: "Todos" }, ...rubro]}
                    styles={customStyles}
                    value={
                      [{ value: "", label: "Todos" }, ...rubro].find(
                        (option) => option.value === form2.watch("idRubro"),
                      ) || null
                    }
                    onChange={(event) => {
                      form2.setValue("idRubro", event?.value ?? "");
                    }}
                  />
                </div>

                <div className="mb-3">
                  <label className="fw-bold mb-2 text-body-highlight">
                    Estado
                  </label>

                  <Select
                    className="mb-0 mi-select mi-select-bordered"
                    classNamePrefix="rs"
                    options={[
                      { value: "", label: "Todos" },
                      { value: "N", label: "Activo" },
                      { value: "S", label: "Inactivo" },
                    ]}
                    styles={customStyles}
                    value={
                      [
                        { value: "", label: "Todos" },
                        { value: "N", label: "Activo" },
                        { value: "S", label: "Inactivo" },
                      ].find(
                        (option) => option.value === form2.watch("bloqueado"),
                      ) || null
                    }
                    onChange={(event) => {
                      form2.setValue("bloqueado", event?.value ?? "");
                    }}
                  />
                </div>
              </div>

              <div className="modal-footer d-flex justify-content-end align-items-center px-4 pb-4 border-0 pt-3">
                <button
                  className="btn btn-sm btn-phoenix-primary px-4 fs-10 my-0 rounded-4"
                  type="button"
                  onClick={() => form2.reset()}
                >
                  <span className="fas fa-arrows-rotate me-2 fs-10"></span>
                  Reiniciar
                </button>

                <button
                  className="btn btn-sm btn-primary px-9 fs-10 my-0 rounded-4"
                  type="submit"
                >
                  Hecho
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
